import React from "react";
import "./index.scss";

const ShootingStarsUpward = () => {
  return (
    <div className="shooting-stars-upwards-container">
      {[...Array(5)].map((_, index) => {
        const randomDuration = Math.random() * 3 + 2;
        return (
          <span
            key={index}
            style={{
              animationDuration: `${randomDuration}s`,
            }}
          ></span>
        );
      })}
    </div>
  );
};

export default ShootingStarsUpward;
